import { attachmentService, deviceService, restClient } from "client-app-core";
import { createUserFeedback } from "orion-components/Dock/Actions/index.js";
import { getTranslation } from "orion-components/i18n";
import { feedEntitiesByTypeSelector } from "orion-components/GlobalData/Selectors";
import { updateContext } from "orion-components/ContextualData/Actions";

export { linkEntities, unlinkEntities } from "./entityProfileActions";
export {
	addRemoveFromCollections,
	addRemoveFromEvents,
	updateActivityFilters,
	createCollection
} from "./commonActions";

export const attachFilesToDevice = (deviceId, entityType, files) => {
	return () => {
		attachmentService.uploadFiles(deviceId, "device", files, (err, result) => {
			if (err) {
				console.log(err);
			}
			console.log(result);
		});
	};
};

export const updateDevice = (deviceId, device, updateEntityData) => {
	return (dispatch, getState) => {
		deviceService.update(deviceId, device, updateEntityData, (err, response) => {
			if (err) {
				console.log(err, response);
			} else if (response?.changes) {
				const context = getState().contextualData[deviceId]?.entity || {};
				const device = response.changes[0]?.new_val || {};
				dispatch(updateContext(deviceId, { ...context, ...device }));
			}
		});
	};
};

export const controlClicked = (feature, deviceId) => {
	return (dispatch, getState) => {
		const commands = typeof feature.command === "string" ? [feature.command] : feature.command;
		let toast;

		// Get device from globalData
		const devices = feedEntitiesByTypeSelector("device")(getState());
		const deviceData = devices[deviceId];

		const promises = commands.map((command) => {
			return new Promise((resolve) => {
				restClient.exec_post(command, JSON.stringify(deviceData), (err, result) => {
					if (result?.message?.includes("approval")) {
						console.log("Access control command response", result.message);
					} else if (err || result.success === false) {
						toast = "error";
						console.log(`There was an error executing command (${command})`, err, result);
					} else {
						if (!toast) {
							toast = "success";
						}
						console.log(`Command (${command}) executed successfully.`);
					}
					resolve();
				});
			});
		});

		Promise.all(promises).then(() => {
			if (toast)
				dispatch(
					createUserFeedback(
						getTranslation(
							`global.profiles.deviceProfile.accessControlWidget.toast.${toast}`,
							feature.label
						),
						null,
						toast === "error"
					)
				);
		});
	};
};
